export const ALUNO_STORE = 'aluno';